<h2 class="title">Cesados</h2>
<br>
<app-page-acciones
  [hasButton]="false"
  [comboOptions]="monthOptions"
  [comboSelected]="currentMonth"
  (comboSelectedChange)="onMonthChange($event)"

  [yearOptions]="yearOptions"
  [yearSelected]="selectedYear"
  (yearSelectedChange)="onYearChange($event)"
  
  [searchQuery]="searchTerm"
  (searchQueryChange)="onSearch($event)"
>
</app-page-acciones>

<app-page-container
  [contentContainerClass]="'cesados-container'"
  [tabs]="tabs"
  [displayedColumns]="displayedColumns"
  [dataSource]="dataSource"
  [actionButtons]="actionButtons"
  [headerClass]="currentHeaderClass"
  [showPreviewCard]="false"
  [isLoading]="isLoading"
  [useServerPagination]="true"
  [paginationLength]="totalElements"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [customTemplates]="{
    employeeName: employeeNameTemplate,
    jobPositionName: jobPositionNameTemplate,
    salary: salaryTemplate,
    startDate: startDateTemplate,
    endDate: endDateTemplate,
    terminationDate: terminationDateTemplate,
    fileContract: fileContractTemplate
  }"
  (tabSelected)="onTabSelected($event)"
  (rowSelected)="onRowSelected($event)"
  (pageChange)="onPageChange($event)"
  [hasCheckbox]="true"
>
  <ng-template #employeeNameTemplate let-row>
    <span class="truncate-text">{{ row.employeeName | capitalize }}</span>
  </ng-template>
  <ng-template #jobPositionNameTemplate let-row>
    <span class="truncate-text">{{ row.jobPositionName | capitalize }}</span>
  </ng-template>
  <ng-template #salaryTemplate let-row> S/. {{ row.salary }} </ng-template>
  <ng-template #startDateTemplate let-row>
    {{ formatDate(row.startDate) }}
  </ng-template>
  <ng-template #endDateTemplate let-row>
    {{ formatDate(row.endDate) }}
  </ng-template>
  <ng-template #terminationDateTemplate let-row>
    {{ formatDate(row.terminationDate) }}
  </ng-template>
  <ng-template #fileContractTemplate let-row>
    <span class="truncate-text">
      <!-- Botón Aceptar -->
      <button
        type="button"
        (click)="onDetail(row)"
        [disabled]="selectedRowId !== row.contractId"
        class="btn-detail"
      >
        <i class="pi pi-eye"></i>
        <span>Ver detalle</span>
      </button>
    </span>
  </ng-template>
</app-page-container>

<div class="cesados-edit-modal">
  <app-cesados-edit-modal
    [(visible)]="mostrarModalEditar"
    [dataToEdit]="dataToEdit"
    (visibleChange)="onDialogClose()"
    (editComplete)="onEditComplete()"
    (openContractModal)="onOpenContractModal($event)"
  ></app-cesados-edit-modal>
</div>

<div class="cesados-register-contract-modal">
  <app-cesados-register-contract-modal
    [(visible)]="mostrarModalContrato"
    [employeeData]="employeeDataContract"
    (visibleChange)="onDialogContractClose()"
    (backStep)="onBackToEditModal()"
    (registerComplete)="onRegisterComplete()"
  ></app-cesados-register-contract-modal>
</div>

<div class="employee-detail-modal">
  <app-employee-detail-modal
    [(visible)]="mostrarModalDetalle"
    [dataToView]="dataDetail"
    (visibleChange)="onDialogDetailClose()"
  ></app-employee-detail-modal>
</div>
